import type { TFunction } from "i18next";
import type {
  DocumentDetailsVersion,
  DocumentVersionSummary,
} from "~/api/types";
import { DocumentVersionStatus, type ReviewPeriod } from "~/config/types";

export function getReviewPeriodLabel(
  period: string | null,
  t: TFunction,
): string | null {
  if (!period) return null;
  const labels: Record<ReviewPeriod, string> = {
    "3 MONTH": t(($) => $.commons.document.reviewPeriods.every3months),
    "6 MONTH": t(($) => $.commons.document.reviewPeriods.every6months),
    "1 YEAR": t(($) => $.commons.document.reviewPeriods.yearly),
  };
  return labels[period as ReviewPeriod] ?? period;
}

export function getPreviousVersion(
  selectedVersion: DocumentDetailsVersion,
  documentVersions: DocumentDetailsVersion[],
): {
  version: DocumentDetailsVersion | undefined;
  versionNumber: number;
} | null {
  const currentIndex = documentVersions.findIndex(
    (v) => v.id === selectedVersion.id,
  );

  if (currentIndex === -1 || currentIndex === documentVersions.length - 1) {
    return null;
  }

  const previousVersion = documentVersions[currentIndex + 1];
  const previousVersionNumber = documentVersions.length - (currentIndex + 1);

  return {
    version: previousVersion,
    versionNumber: previousVersionNumber,
  };
}

export function findDuplicateDocumentVersion({
  documentVersions,
  title,
  categoryId,
}: {
  documentVersions: DocumentVersionSummary[] | undefined;
  title: string;
  categoryId: number | null;
}): DocumentVersionSummary | undefined {
  if (!documentVersions || categoryId === null) return undefined;
  const normalizedTitle = title.trim().toLowerCase();
  if (!normalizedTitle) return undefined;
  return documentVersions.find(
    (dv) =>
      dv.document.category.id === categoryId &&
      dv.status !== DocumentVersionStatus.archived &&
      dv.title.trim().toLowerCase() === normalizedTitle,
  );
}
